import { CircularProgress } from "@mui/material";
import React from "react";
import { NavigateFunction } from "react-router-dom";
import { logout } from "../SharedComponents/LoginGuard/loginGuard";
import { withNavigationHooks } from "../SharedComponents/withNavigationHooks";
import { environment } from "../utils/environment";
import {
  SeducSelectYearController,
  SeducSelectYearControllerDelegate,
} from "./controller";

interface State {
  year: number;
  isLoading: boolean;
  error: boolean;
}

interface Props {
  navigationHooks: NavigateFunction;
}

class SeducSelectYear
  extends React.Component<Props, State>
  implements SeducSelectYearControllerDelegate
{
  private static AnoNames = [
    "1º Ano do Ensino Fundamental",
    "2º Ano do Ensino Fundamental",
    "3º Ano do Ensino Fundamental",
    "4º Ano do Ensino Fundamental",
    "5º Ano do Ensino Fundamental",
    "6º Ano do Ensino Fundamental",
    "7º Ano do Ensino Fundamental",
    "8º Ano do Ensino Fundamental",
    "9º Ano do Ensino Fundamental",
    "1º Ano do Ensino Médio",
    "2º Ano do Ensino Médio",
    "3º Ano do Ensino Medio",
  ];

  private controller: SeducSelectYearController;

  constructor(props: Props) {
    super(props);
    this.controller = new SeducSelectYearController(this);
    this.state = {
      year: -1,
      isLoading: false,
      error: false,
    };
  }

  async componentDidMount(): Promise<void> {
    await this.handleSubmit();
  }

  submitedYear(): void {
    window.location.href = environment.baseUrl;
  }

  applicationShouldLogout(): void {
    logout();
  }

  genericError(): void {}

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ year: parseInt(event.target.value) });
  };

  handleSubmit = async () => {
    await this.controller.assignYear(99);
  };

  render() {
    return this.state.isLoading ? <CircularProgress sx={{ mt: 2 }} /> : <></>;
    // if (this.state.error) {
    //   return (
    //     <Box display="flex" flexDirection="column" width="100%" alignItems="center" justifyContent="center">
    //       <Typography variant="h5" gutterBottom mt={3}>
    //       Não há formulários disponíveis para o ano selecionado!
    //     </Typography>
    //     <Button
    //         variant="contained"
    //         color="primary"
    //         sx={{ color: "white", mt: 2 }}
    //         onClick={() => this.setState({error: false})}
    //       >
    //         Voltar
    //       </Button>
    //     </Box>
    //   );
    // }

    // return (
    //   <Box display="flex" flexDirection="column" width="100%" alignItems="center" justifyContent="center">
    //     <LoginGuard />
    //     <Header logoutEnabled={true} />
    //     <Typography variant="h6" gutterBottom mt={3}>
    //       Selecione um ano:
    //     </Typography>
    //     <RadioGroup value={this.state.year} onChange={this.handleChange}>
    //       {SeducSelectYear.AnoNames.map((name, index) => (
    //         <FormControlLabel key={index + 1} value={index + 1} control={<Radio />} label={name} />
    //       ))}
    //     </RadioGroup>

    //     {this.state.isLoading ? (
    //       <CircularProgress sx={{ mt: 2 }} />
    //     ) : (
    //       <Button
    //         variant="contained"
    //         color="primary"
    //         sx={{ color: this.state.year === -1 ? "inherit" : "white", mt: 2 }}
    //         onClick={this.handleSubmit}
    //         disabled={this.state.year === -1 || this.state.isLoading}
    //       >
    //         Confirmar
    //       </Button>
    //     )}
    //   </Box>
    // );
  }
}

export default withNavigationHooks(SeducSelectYear);
